import React, { useEffect, useState, useCallback } from 'react';
import LandingPage from './pages/landing/LandingPage';

const THEME_STORAGE_KEY = 'siameseai-landing-theme';
const VALID_PREFERENCES = ['system', 'light', 'dark'];

function getStoredPreference() {
  if (typeof window === 'undefined') {
    return 'system';
  }
  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  return VALID_PREFERENCES.includes(stored) ? stored : 'system';
}

function getSystemTheme() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'dark';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function App() {
  const [themePreference, setThemePreference] = useState(getStoredPreference);
  const [systemTheme, setSystemTheme] = useState(getSystemTheme);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (event) => setSystemTheme(event.matches ? 'dark' : 'light');
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  const resolvedTheme = themePreference === 'system' ? systemTheme : themePreference;

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(resolvedTheme);
    window.localStorage.setItem(THEME_STORAGE_KEY, themePreference);
  }, [resolvedTheme, themePreference]);

  const handleSetThemePreference = useCallback((next) => {
    if (VALID_PREFERENCES.includes(next)) {
      setThemePreference(next);
    }
  }, []);

  return (
    <LandingPage
      theme={resolvedTheme}
      themePreference={themePreference}
      onSetThemePreference={handleSetThemePreference}
    />
  );
}

export default App;
